import { Pipe, PipeTransform } from "@angular/core";
import { Observable, of, timer } from "rxjs";
import { map } from "rxjs/operators";
import { left } from "../functions";

@Pipe({
  name: "left$"
})
export class LeftPipe implements PipeTransform {
  transform(time: null | number, negs = false): Observable<number> {
    if (!time) {
      return of(0);
    }

    return timer(0, 1_000).pipe(map(() => left(time, negs)));
  }
}
